import React from 'react'

type HTMLTextProps = {
  html: string
  className?: string
}

const HTMLText: React.FC<HTMLTextProps> = ({ html, className = '' }) => {
  return (
    <span
      className={className}
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  )
}

export default HTMLText
